import React, { useState } from 'react';
import { useContent } from '../../hooks/useContent';
import LoadingSpinner from '../common/LoadingSpinner';
import ErrorMessage from '../common/ErrorMessage';

const FaqSection = () => {
    const { content, isLoading, isError, error, loadContentBySection } = useContent('faq');
    const [activeIndex, setActiveIndex] = useState(null);

    // Get the FAQ content data
    const faqData = content.length > 0 ? content[0].content_data : null;

    const handleToggle = (index) => {
        setActiveIndex(index === activeIndex ? null : index);
    };

    if (isLoading) {
        return (
            <section className="section faq-area ptb_100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <LoadingSpinner size="lg" />
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    if (isError) {
        return (
            <section className="section faq-area ptb_100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <ErrorMessage error={error} onRetry={() => loadContentBySection('faq')} />
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    if (!faqData) {
        return (
            <section className="section faq-area ptb_100">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="text-center">
                                <p>No FAQ content available.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className="section faq-area ptb_100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-10 col-lg-8">
                        {/* Section Heading */}
                        <div className="section-heading text-center">
                            <h2 className="text-capitalize">{faqData.headingTwo}</h2>
                            <p className="d-none d-sm-block mt-4">{faqData.headingText}</p>
                            <p className="d-block d-sm-none mt-4">{faqData.headingTexttwo}</p>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-12">
                        {/* FAQ Content */}
                        <div className="faq-content">
                            {/* SalesPinch Accordion */}
                            <div className="accordion" id="SalesPinch-accordion">
                                <div className="row justify-content-center">
                                    <div className="col-12 col-md-10 col-lg-8">
                                        {/* Single Accordion Item */}
                                        {faqData.faqData && faqData.faqData.map((item, idx) => (
                                            <div key={`ft_${idx}`} className="card border-top-0 border-left-0 border-right-0 border-bottom">
                                                {/* Card Header */}
                                                <div className="card-header bg-inherit border-0 p-0">
                                                    <h2 className="mb-0">
                                                        <button
                                                            className="btn px-0 py-3"
                                                            type="button"
                                                            onClick={() => handleToggle(idx)}
                                                        >
                                                            {item.title}
                                                        </button>
                                                    </h2>
                                                </div>
                                                {/* Card Body */}
                                                {activeIndex === idx && (
                                                    <div className="card-body px-0 py-3">
                                                        {item.content}
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FaqSection;